<template>
  <div
    data-qa="wrapper"
    :class="$style.wrapper"
  >
    <div :class="$style.labelSection">
      <base-label
        v-if="label || description"
        :class="$style.label"
        data-qa="label"
        :for="id"
      >
        <span>
          <slot
            name="label"
            :label="label"
          >
            <span v-html="label" />
          </slot>
        </span>
        <slot name="hint" />
        <slot
          name="description"
          :description="description"
        >
          <div
            v-if="description"
            :class="$style.description"
            data-qa="description"
            v-html="description"
          />
        </slot>
      </base-label>
      <slot name="additional-control" />
    </div>
    <slot :id="id" />
    <template v-if="!hideErrors && invalid">
      <base-error
        v-for="(error, index) in showOnlyOneError ? [errors[0]] : errors"
        :key="index"
      >
        <slot
          name="error"
          :error="error"
        >
          {{ error }}
        </slot>
      </base-error>
    </template>
    <template v-else>
      <div :class="$style.warning">
        <slot name="warning" />
      </div>
      <div :class="$style.info">
        <slot name="info" />
      </div>
    </template>
  </div>
</template>

<script>
import { nanoid } from 'nanoid';
import BaseError from '@/shared/legacy/ui/error/error.vue';
import BaseLabel from '@/shared/legacy/ui/label/label.vue';

export default {
  name: 'FormField',
  components: {
    BaseLabel,
    BaseError
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    invalid: Boolean,
    hideErrors: Boolean,
    showOnlyOneError: Boolean,
    errors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      id: nanoid(10)
    };
  }
};
</script>

<style module lang="less">
@import '~@less/common/variables.less';

.delimiter {
  padding-bottom: 24px;
  margin-bottom: 16px;
  border-bottom: 1px solid @borderColor;
}

.labelSection {
  display: flex;
  justify-content: space-between;
  align-items: self-start;
}

.label {
  margin-bottom: 4px;
  display: inline-flex;
  align-items: center;
  width: max-content;
}
.description {
  color: #999;
  font-size: 14px;
  line-height: 18px;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 4px 0 10px;
}
.warning:not(:empty) {
  padding-top: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: @yellowColor;
}
.info:not(:empty) {
  padding-top: 4px;
  color: #050505;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.5;
}
</style>

<i18n lang="json">{}</i18n>
